(($) => {  
    
    // add google tag manager late/based on interaction, to help with time to interactable

    $(document).ready(function(){
        /** init GTM milliseconds - this can be adjusted */
        setTimeout(initGTM, 7000);
    
        // Trigger GTM initialization on user interaction
        $(document).on('scroll mousemove touchstart', initGTMOnEvent);
    
        function initGTMOnEvent(event){
            initGTM();
            $(document).off(event.type, initGTMOnEvent); // Remove event listener after it is triggered
        }
    
        function initGTM(){
            if(window.gtmDidInit){
                return false; // Don't initialize if already done
            }
            window.gtmDidInit = true;
    
            // Insert GTM script tag
            (function(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-WX244W8');
        }
    });

    /********************* Smooth Scroll to Anchor **********************/ 
    $(document).ready(function() {
        $('a[href*="#"]').on('click', function(e) {
            e.preventDefault();
            var target = $(this).attr('href');
            var $targetElement = $(target);
        
            if ($targetElement.length) {
                $('html, body').animate({
                    scrollTop: $targetElement.offset().top - 150
                }, 1000);
            } else {
                console.warn('Target element not found: ' + target);
            }
        });
    });
    
    /********************* Modal **********************/ 
    const modalOpenBtns = $('button.modal[data-modal]');
    const modalCloseBtn = $('button[data-dismiss="modal"]');
    const modalBanner = $('.header_banner.modal[data-modal]');
    const bannerDismiss = $('.dismiss_header_banner');

    bannerDismiss.on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.header_banner').fadeOut(300);
        // set a cookie to remember the user has dismissed the banner
        document.cookie = 'dismissed_banner=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
    });
        
    modalBanner.on('click', (e) => {
        e.preventDefault();
        const target = $(e.currentTarget).data('modal');
        $(`#modal[data-modal=${target}]`).fadeIn(300, function() {
            $('body').css('overflow', 'hidden');
        });
    });


    modalOpenBtns.on('click', (e) => {
        e.preventDefault();
        const target = $(e.currentTarget).data('modal');
        $(`#modal[data-modal=${target}]`).fadeIn(300, function() {
            $('body').css('overflow', 'hidden');
        });
    });

    modalCloseBtn.on('click', (e) => {
        $(`#modal[data-modal]`).fadeOut(300, function() {
            $('body').css('overflow', 'auto');
        });
    });

   $('.modalBackdrop').on('click', function(e) {
        if (e.target.id == 'modal') {
            $(this).fadeOut(300, function() {
                $('body').css('overflow', 'auto');
            });
        }
    });
   
    /********************* Modal articleShare **********************/ 
    $('.shareOpen').on('click', function(e) {
        $('#share-modal').fadeIn(300, function() {
            $('body').css('overflow', 'hidden');
        });
    });
    
    $('.shareClose').on('click', function(e) {
        $('#share-modal').fadeOut(300, function() {
            $('body').css('overflow', 'auto');
        });
    });
    
    $('.shareModalBackdrop').on('click', function(e) {
        if (e.target.id == 'share-modal') {
            $(this).fadeOut(300, function() {
                $('body').css('overflow', 'auto');
            });
        }
    });

    /********************* Mobile CTA Btn **********************/ 
    if (window.innerWidth < 768) {
        $(window).on('scroll', function() {
            // get the height of the screen
            if (window.scrollY > 50) {
                $('.cta_mobile').addClass('active');
            } else {
                $('.cta_mobile').removeClass('active');
            }
        });
    }

    // product page buttons appear only once you've scrolled past early static buttons            
    if($('.product_page_container .product_button--end')[0]){
        const $target_element = $('.product_page_container .product_button--end');
    
        $(window).on('scroll', function() {
            let element_top = $target_element.offset().top;
            let element_bottom = element_top + $target_element.outerHeight();
            let viewport_top = $(window).scrollTop();

            if(viewport_top > element_bottom){
                $('.cta_mobile--product_page').addClass('active');
            }
            else{
                $('.cta_mobile--product_page').removeClass('active');
            }
        });
    }

    // on window orientation change run potential screen resize events

    $(window).on("orientationchange", function(){
        $(window).trigger("resize");
    });

    /********************* Back to top button - removed from site but left code if we want to re-add **********************/
    // append the back to top button to the body
    // const backToTop = () => {        
    //     $('body').append('<div class="backToTop"><svg id="Component_4600_7" data-name="Component 4600 – 7" xmlns="http://www.w3.org/2000/svg" width="47.584" height="47.584" viewBox="0 0 47.584 47.584"><path id="Path_27511" data-name="Path 27511" d="M23.792,0A23.792,23.792,0,1,1,0,23.792,23.792,23.792,0,0,1,23.792,0Z" fill="#004b87"/><path id="Icon_core-arrow-top" data-name="Icon core-arrow-top" d="M23.262,8.489,15.9,1.125,8.534,8.489,9.772,9.727l5.251-5.251v15.6h1.75V4.476l5.251,5.251,1.238-1.238Z" transform="translate(7.902 12.186)" fill="#fff"/></svg></div>');

    //     $('.backToTop').on('click', (e) => {
    //         e.stopPropagation();
    //         $('html, body').animate({
    //             scrollTop: 0
    //         }, 1000);
    //     });
    // }
    // let  backToTopIsActice = false;
    // $(window).on('scroll', function() {
    //     if (window.scrollY > 200 && !backToTopIsActice) {
    //         backToTop();
    //         backToTopIsActice = !backToTopIsActice;
    //     } else if (window.scrollY < 200 && backToTopIsActice) {
    //         $('.backToTop').remove();
    //         backToTopIsActice = !backToTopIsActice;
    //     }
    // });

    /********************* Go back Button **********************/
    // attach with onclick attribute in html, or extend this with event listeners if needed
    window.goBackAPage = function(){
        window.history.back();
    }

    /********************* Accordion toggler *******************/
    function setupAccordion(itemClass, contentClass) {
        $(itemClass).on('click', function () {
            const clicked_item = $(this);
            const active_item = $(`${itemClass}.active`);
    
            if (active_item.length) {
                active_item.removeClass('active');
                active_item.find(contentClass).fadeOut(200, function() {
                    if (active_item[0] !== clicked_item[0]) {
                        clicked_item.addClass('active');
                        clicked_item.find(contentClass).fadeIn(250);
                    }
                });
            } else {
                clicked_item.addClass('active');
                clicked_item.find(contentClass).fadeIn(250);
            }
        });
    }
    
    // Usage
    setupAccordion('.accordion__item', '.accordion__content');
    setupAccordion('.more_info_item', '.more_info_item--content');

    /********************* Search **********************/
    $('#mobile_s, #mobileSearchBar, #s, .catalogueSearch__input, .postSearch__input').on('keyup', function() {
        return tpflCustomAjaxFetch(this);
    });

    $(document).on('click', function(e) {
        // if the target is not the search input or the search results
        if (!$(e.target).is('.ajax-search') && !$(e.target).is('.ajax-search-results')) {
            $('.ajax-search-results').hide();
        }
    });

    const mobile_search_toggle = $('.mobile_search_toggler');

    if (mobile_search_toggle.length) {
        mobile_search_toggle.on('click', function() {
            $('#mobileSearch').fadeIn();
            $('#mobileSearchBar').focus();
            $('.ajax-search-results').addClass('active');
        });
    }

    if ($('#mobileSearch').length) {
        $('#mobileSearch').on('click', function(e) {
            if (e.target.id == 'mobileSearch') {
                $(this).fadeOut();
            }
        });
    }

    $('#mobileSearch .mobileSearchForm svg').on('click', function(e) {
        $('#mobileSearch').fadeOut();
        $('.ajax-search-results').removeClass('active');
    });

})(jQuery);